var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dean-switch-container"},[_c('label',{staticClass:"dean-switch"},[_c('div',{class:_vm.deanSwitchClass,on:{"click":_vm.valueChanged}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }